import { createFileRoute } from '@tanstack/react-router';
import { CompensationRulePage } from '@/features/rules/pages/rules-pages';

export const Route = createFileRoute('/_app/rules/compensation')({ component: CompensationRulePage });
